import '../../libs/polyfills/polyfills';
import Ads from '../../components/ads/Ads';
import BannerPin from '../../components/ads/BannerAdsPin';
import skinAdsPin from '../../components/ads/skinAdsPin';
import analytics from '../../components/analytics/Analytics';
import picturefill from 'picturefill';
import usertiming from 'usertiming';
import ScoreStrip from '../../components/scorestrip/scorestrip';
import Sidebar from '../../components/sidebar/sidebar';
import lazysizes from 'lazysizes';

var ads = new Ads();
ads.enableRenderOnScroll();
ads.renderPageAds();

// Set up sidebar components
new Sidebar();

//temporary for external access
//being used in big-board.js and marquee gallery
window.FsAds = ads;

analytics.sendPageView();

if (document.querySelector('wis-scorestrip')) {
    new ScoreStrip().init();
}

//object can be reused when importing this script
export default {
	'ads' : ads,
	'analytics' : analytics
}



// WEBPACK FOOTER //
// ./assets/layouts/base/base.js